<form [formGroup]="savedQueryFormGroup" (ngSubmit)="submit()">
    <section class="sh-dialog__content">
        <sh-form-multi-select
            [id]="'query-select'"
            [placeholderMsg]="'components.saved-queries.load-saved-query-dialog.select-query' | translate"
            [searchPlaceholderMsg]="'components.saved-queries.load-saved-query-dialog.search-placeholder' | translate"
            [label]="'components.saved-queries.load-saved-query-dialog.label' | translate"
            [control]="querySearchControl"
            [errorResponse]="ErrorResponse.TOUCHED"
            [options]="savedQueriesFormSelectOptions$ | async"
            [search]="true"
            [inOverflownContainer]="true"
            [listCappedMsg]="'components.saved-queries.load-saved-query-dialog.capped-results' | translate"
            [noResultsFoundMsg]="'components.saved-queries.load-saved-query-dialog.no-results' | translate"
            (searchTerm)="onSearchTermChange($event)"
        >
        </sh-form-multi-select>
    </section>
    <footer class="sh-dialog__footer">
        <div class="sh-action-group -sh-align-end">
            <button type="submit" class="sh-button sh-action-group__item" [disabled]="savedQueryFormGroup.invalid">{{ config.data.search }}</button>
            <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ config.data.cancel }}</button>
        </div>
    </footer>
</form>
